const PARTNERS_NOTE = (
  <>
    Audition Expert collabore avec les partenaires officiels suivants : <strong>Audio Pour Tous</strong>,{" "}
    <strong>VivaSon</strong> et <strong>Solution Audition</strong>. Audition Expert organise la mise en relation
    entre les clients et ces partenaires, mais chaque centre demeure seul responsable de ses prestations,
    disponibilités, professionnels et engagements. Les partenaires ne sont pas les éditeurs du site.
  </>
);

const PAGES = {
  mentions: {
    title: "Mentions légales",
    sections: [
      { h: "Éditeur du site", p: "Audition Expert — [À COMPLÉTER : raison sociale, forme juridique, capital, RCS, SIRET, adresse du siège]." },
      { h: "Directeur de la publication", p: "[À COMPLÉTER]" },
      { h: "Hébergeur", p: "[À COMPLÉTER : nom, adresse, téléphone de l'hébergeur]" },
      { h: "Contact", p: "contact@auditionexpert.com" },
    ],
  },
  cgu: {
    title: "Conditions générales d'utilisation",
    sections: [
      { h: "Objet", p: "Les présentes CGU régissent l'utilisation du service gratuit de mise en relation entre les clients et les centres auditifs partenaires (Audio Pour Tous, VivaSon, Solution Audition)." },
      { h: "Service gratuit", p: "Audition Expert est un service entièrement gratuit. Aucun paiement, abonnement ou frais n'est demandé aux utilisateurs. La prise de rendez-vous et le bilan proposé par les partenaires sont sans engagement." },
      { h: "Partenaires officiels", p: PARTNERS_NOTE },
      { h: "Responsabilité", p: "Audition Expert facilite la mise en relation mais n'assure pas les prestations auditives elles-mêmes. Les rendez-vous ne sont confirmés qu'après validation par l'équipe Audition Expert." },
      { h: "Compte utilisateur", p: "Chaque utilisateur est responsable de la confidentialité de ses identifiants et de l'exactitude des informations fournies." },
      { h: "Modification des CGU", p: "Audition Expert se réserve le droit de modifier les présentes CGU. Les utilisateurs seront informés de toute modification substantielle." },
    ],
  },
  privacy: {
    title: "Politique de confidentialité",
    sections: [
      { h: "Responsable de traitement", p: "Audition Expert — [À COMPLÉTER : coordonnées du responsable de traitement et du DPO le cas échéant]." },
      { h: "Données collectées", p: "Prénom, nom, e-mail, téléphone, code postal, centre sélectionné, motif général du rendez-vous, préférence horaire. Aucune donnée médicale détaillée n'est collectée." },
      { h: "Finalités", p: "Organisation de la prise de rendez-vous auprès du centre choisi, gestion de votre compte, envoi d'informations lorsque vous y consentez." },
      { h: "Destinataires", p: (
          <>Vos données ne sont transmises qu'au <strong>centre partenaire</strong> que vous avez sélectionné, dans le but exclusif d'organiser votre rendez-vous. Les partenaires officiels sont Audio Pour Tous, VivaSon et Solution Audition.</>
        ) },
      { h: "Durée de conservation", p: "Les données sont conservées pendant la durée nécessaire à la gestion de votre demande, puis anonymisées ou supprimées sur demande." },
      { h: "Vos droits", p: "Vous disposez des droits d'accès, de rectification, d'effacement, d'opposition et de portabilité. Vous pouvez les exercer via la page « Exercer mes droits »." },
      { h: "Partenaires", p: PARTNERS_NOTE },
    ],
  },
  cookies: {
    title: "Politique de cookies",
    sections: [
      { h: "Utilisation des cookies", p: "Audition Expert utilise uniquement les cookies strictement nécessaires au fonctionnement du service (session, authentification)." },
      { h: "Cookies de mesure d'audience", p: "[À COMPLÉTER : liste des cookies analytiques utilisés, le cas échéant]." },
      { h: "Gestion", p: "Vous pouvez à tout moment gérer les cookies depuis les paramètres de votre navigateur." },
    ],
  },
};

export default function Legal({ page }) {
  const p = PAGES[page];
  if (!p) return null;
  return (
    <div>
      <section className="hero-bg py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <div className="text-gold uppercase tracking-widest text-sm font-semibold">Informations légales</div>
          <h1 className="font-heading text-4xl text-primary-blue mt-3" data-testid="legal-title">{p.title}</h1>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-14 space-y-8">
        {p.sections.map((s) => (
          <div key={s.h} className="bg-white p-6 md:p-8 rounded-2xl border border-slate-100 card-lux">
            <h2 className="font-heading text-xl text-primary-blue">{s.h}</h2>
            <div className="mt-3 text-slate-700 leading-relaxed">{s.p}</div>
          </div>
        ))}
      </section>
    </div>
  );
}
